import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMyInvitations, acceptInvitation, declineInvitation } from '../../store/actions/invitation';
import { fetchUserTenants } from '../../store/actions/users';
import { IoNotificationsOutline } from 'react-icons/io5';

const NotificationCenter = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const invitations = useSelector(state => state.invitation.my);
    const isAuth = useSelector(state => state.users.auth);
    const tenantListLoaded = useSelector(state => state.users.data?.tenantListLoaded);
    const activeTenantBlocked = useSelector(state => state.users.data?.activeTenantBlocked);

    useEffect(() => {
        if (isAuth && tenantListLoaded && !activeTenantBlocked) dispatch(fetchMyInvitations());
    }, [isAuth, tenantListLoaded, activeTenantBlocked, dispatch]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleAccept = async (id) => {
        await dispatch(acceptInvitation(id));
        dispatch(fetchUserTenants());
    };

    return (
        <div className="notification-center" ref={ref}>
            <button className="notification-trigger" onClick={() => setOpen(o => !o)}>
                <IoNotificationsOutline size={24} />
                {invitations.length > 0 && (
                    <span className="notification-count">{invitations.length}</span>
                )}
            </button>

            {open && (
                <div className="notification-dropdown">
                    <div className="notification-header">Notifikácie</div>
                    {invitations.length === 0 ? (
                        <div className="notification-empty">Žiadne notifikácie</div>
                    ) : (
                        invitations.map(inv => (
                            <div key={inv._id} className="notification-item">
                                <div className="notification-text">
                                    <strong>{inv.tenantId?.companyName}</strong>
                                    <span>Pozýva ťa {inv.invitedBy?.name} {inv.invitedBy?.surname}</span>
                                </div>
                                <div className="notification-actions">
                                    <button className="notif-btn notif-btn-accept" onClick={() => handleAccept(inv._id)}>
                                        Prijať
                                    </button>
                                    <button className="notif-btn notif-btn-decline" onClick={() => dispatch(declineInvitation(inv._id))}>
                                        Odmietnuť
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default NotificationCenter;
